export const AUTHENTICATION_SET_DATA = 'AUTHENTICATION_SET_DATA'
export const AUTHENTICATION_SET_COMPANY = 'AUTHENTICATION_SET_COMPANY'
